/*eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');
import toast from '../../services/toast';
import {mapGetters, mapState} from 'vuex';
export default {
  name: 'payment-history',
  components: {},
  props: [],
  data () {
    return {
      paymentHistory:{}
    }
  },
  computed: {
    ...mapGetters([
      'getPaymentHistoryDetailsState'
    ]),
    getUserSubscription(){
      this.paymentHistory = this.$store.getters.getPaymentHistoryDetailsState.data
    }
  },
  mounted () {
  },
  methods: {

  },
  watch:{
    getUserSubscription(){
      return this.$store.getters.getPaymentHistoryDetailsState
    }
  }
}
